import { render, staticRenderFns } from "./OrderMenuPlanner.vue?vue&type=template&id=ee8993a6&scoped=true"
import script from "./OrderMenuPlanner.vue?vue&type=script&lang=js"
export * from "./OrderMenuPlanner.vue?vue&type=script&lang=js"
import style0 from "./OrderMenuPlanner.vue?vue&type=style&index=0&id=ee8993a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8993a6",
  null
  
)

export default component.exports